// reducer - state management
import { LOGIN, LOGOUT } from 'store/reducers/actions';
import { createContext, useEffect, useReducer } from 'react';

// third-party
// import { Chance } from 'chance';
// project-imports
import Loader from 'components/Loader';
import PropTypes from 'prop-types';
import authReducer from 'store/reducers/auth';
import axios from 'utils/axios';

// const chance = new Chance();

// constant
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  token: null
};

const setSession = (token) => {
  if (token) {
    localStorage.setItem('token', token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const BUSContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  console.log('🚀 ~ JWTProvider ~ state:', state);

  // useEffect(() => {
  //   const init = async () => {
  //     try {
  //       const bearerToken = localStorage.getItem('bearerToken');
  //       setBearerToken(bearerToken);
  //       if (bearerToken) {
  //         dispatch({
  //           type: LOGIN,
  //           payload: {
  //             isLoggedIn: true,
  //             user
  //           }
  //         });
  //       } else {
  //         dispatch({
  //           type: LOGOUT
  //         });
  //       }
  //     } catch (err) {
  //       // console.error(err);
  //       dispatch({
  //         type: HASERROR,
  //         payload: {
  //           error: err
  //         }
  //       });
  //     }
  //   };

  //   init();
  // }, [bearerToken]);

  useEffect(() => {
    const init = async () => {
      try {
        const token = localStorage.getItem('token');
        setSession(token);
        if (token) {
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              token
            }
          });
        } else {
          dispatch({
            type: LOGOUT
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: LOGOUT
        });
      }
    };
    init();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post('/login', { email, password });
    const { token, user } = response.data;
    setSession(token);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user: user,
        token: token
      }
    });
  };

  const register = async ({ first_name, last_name, phone, email, password, password_confirmation }) => {
    const response = await axios.post('/register', {
      first_name,
      last_name,
      phone,
      email,
      password,
      password_confirmation
    });

    // setClientRegister(response.data);

    return response;
  };

  const logout = async () => {
    try {
      const response = await axios.post('/logout');
      setSession(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      dispatch({ type: LOGOUT });
      return response;
    } catch (error) {
      console.error('Logout failed:', error);
      // Handle error appropriately
      throw error;
    }
  };
  const changeEmail = async (new_email, password) => {
    const response = await axios.put(`/change_email`, { new_email, password });
    return response;
  };
  const changePassword = async (old_password, new_password) => {
    const response = await axios.put(`/change_email`, { old_password, new_password });
    return response;
  };
  const forgotPassword = async (email) => {
    const response = await axios.post(`/forgot-password`, { email });
    return response;
  };
  const resetPassword = async (token, email, password, password_confirmation) => {
    const response = await axios.post(`/reset-password`, {
      token,
      email,
      password,
      password_confirmation
    });
    return response;
  };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <BUSContext.Provider value={{ ...state, login, logout, register, changeEmail, changePassword, forgotPassword, resetPassword }}>
      {children}
    </BUSContext.Provider>
  );
};

JWTProvider.propTypes = {
  children: PropTypes.node
};

export default BUSContext;
